<template>
    <div class="d-flex justify-space-between">
        <div class="secondary--text text--darken-4 font-weight-bold">
            {{ now | convertToDateAndDay }}
        </div>
        <!-- <v-spacer></v-spacer> -->
        <div class="primary--text font-weight-bold">
            {{ now | convertToTime }}
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    filters: {
        convertToDateAndDay(value) {
            if (value) {
                return value.format("MMM DD, ddd");
            }

            return null;
        },
        convertToTime(value) {
            if (value) {
                return value.format("LT");
            }

            return null;
        }
    },
    data: () => ({
        now: null
    }),
    mounted() {
        setInterval(() => {
            this.now = moment();
        }, 1000);
    }
}
</script>